export enum AlignmentOption {
  START = 'start',
  CENTER = 'center',
  END = 'end'
}
